import { Route, Routes } from 'react-router-dom';
import { DashboardLayoutObs } from '../components/DashboardLayout';
import Loadable from '../components/Loadable';
import { lazy } from 'react';
import PrivateRoute from './PrivateRoute';

// --- Các trang chính ---
const HomePage = Loadable(lazy(() => import("../pages/home")));
const StationPage = Loadable(lazy(() => import("../pages/station")));
const NotFoundPage = Loadable(lazy(() => import("../pages/NotFound")));
const AboutUsPage = Loadable(lazy(() => import("../pages/about")));
const LoginPage = Loadable(lazy(() => import("../pages/login")));

// --- Các trang quản lý ---
const DamManagementPage = Loadable(lazy(() => import("../pages/management/dam")));
const DamTypeManagementPage = Loadable(lazy(() => import("../pages/management/dam-type")));
const RiverManagementPage = Loadable(lazy(() => import("../pages/management/river")));
const PostManagementPage = Loadable(lazy(() => import("../pages/management/post")));
const CameraManagementPage = Loadable(lazy(() => import("../pages/management/camera")));
const AccountManagementPage = Loadable(lazy(() => import("../pages/management/account")));
const RoleManagementPage = Loadable(lazy(() => import("../pages/management/role")));

// --- Các trang bài viết ---
const PostListPage = Loadable(lazy(() => import("../pages/post/PostListPage")));
const PostDetailPage = Loadable(lazy(() => import("../pages/post/PostDetailPage")));


function RouterApp() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={<DashboardLayoutObs />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/stations/:stationId" element={<StationPage/>} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/posts" element={<PostListPage />} />
        <Route path="/posts/:postId" element={<PostDetailPage />} />
        <Route element={<PrivateRoute />}>
          <Route path="/dam-management" element={<DamManagementPage />} />
          <Route path="/account-management" element={<AccountManagementPage/>} />
          <Route path="/post-management" element={<PostManagementPage />} />
          <Route path="/role-management" element={<RoleManagementPage/>} />
          <Route path="/dam-type-management" element={<DamTypeManagementPage />} />
          <Route path="/river-management" element={<RiverManagementPage />} />
          <Route path="/camera-management" element={<CameraManagementPage />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />

    </Routes>
  );
}

export default RouterApp;